import { ITEMBOUNDSCHANGE } from '../../constants.js';
import { inArray } from '../../utils/functions.js';
import { AdornerBase } from './AdornerBase.js';
import { ConnectorVisual } from './ConnectorVisual.js';

class ConnectorsAdorner extends AdornerBase {
    constructor(diagram, options) {
        super(diagram, options);
        this._refreshHandler = (e) => {
            if (e.item === this.shape) {
                this.refresh();
            }
        };
    }
    show(shape) {
        this._visible = true;
        this.shape = shape;
        this.diagram.bind(ITEMBOUNDSCHANGE, this._refreshHandler);
        this.connectors = [];
        this._clearVisual();
        const len = shape.connectors.length;
        for (let i = 0; i < len; i++) {
            const ctr = new ConnectorVisual(shape.connectors[i]);
            this.connectors.push(ctr);
            this.visual.append(ctr.visual);
        }
        this.visual.visible(true);
        this.refresh();
    }
    _clearVisual() {
        if (this.diagram._cachedTouchTarget) {
            this._keepCachedTouchTarget();
        }
        else {
            this.visual.clear();
        }
    }
    _keepCachedTouchTarget() {
        const visualChildren = this.visual.children;
        const childrenCount = visualChildren.length;
        const index = inArray(this.diagram._cachedTouchTarget, visualChildren);
        for (let i = childrenCount - 1; i >= 0; i--) {
            if (i === index) {
                continue;
            }
            this.visual.remove(visualChildren[i]);
        }
    }
    destroy() {
        this.diagram.unbind(ITEMBOUNDSCHANGE, this._refreshHandler);
        this.shape = undefined;
        this._visible = undefined;
        this.visual.visible(false);
    }
    _hitTest(p) {
        let ctr, i;
        for (i = 0; i < this.connectors.length; i++) {
            ctr = this.connectors[i];
            if (ctr._hitTest(p)) {
                ctr._hover(true);
                this.diagram.toolService._hoveredConnector = ctr;
                break;
            }
        }
    }
    refresh() {
        if (this.shape) {
            let bounds = this.shape.bounds();
            bounds = this.diagram.modelToLayer(bounds);
            this.visual.position(bounds.topLeft());
            this.connectors.forEach(function (ctr) {
                ctr.refresh();
            });
        }
    }
}

export { ConnectorsAdorner };
